import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
export var NotificationDrawerListItemBody = function NotificationDrawerListItemBody(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      timestamp = _a.timestamp,
      props = __rest(_a, ["children", "className", "timestamp"]);

  return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, props, {
    className: css(styles.notificationDrawerListItemDescription, className)
  }), children), timestamp && React.createElement("div", {
    className: css(styles.notificationDrawerListItemTimestamp, className)
  }, timestamp));
};